export const SETTINGS_UPDATE = 'SETTINGS_UPDATE';
